import React from "react";

const LogoScroller = ({className = 'logo-div left-side'}) => {
    return (
        <div className={className}>
            <div className={'scroller'}>
                {
                    [...Array(12)].map((_, index) => (
                        <div className={'d-flex justify-content-center align-items-center w-100'}>
                            {
                                [...Array(2)].map((_, index) => (
                                    <img
                                        key={index}
                                        src={require("../../assets/images/png/theme/login-logo.png")}
                                        alt={`orzax-club-login-logo`}
                                    />
                                ))
                            }
                        </div>
                    ))
                }
                {
                    [...Array(12)].map((_, index) => (
                        <div className={'d-flex justify-content-center align-items-center w-100'}>
                            {
                                [...Array(2)].map((_, index) => (
                                    <img
                                        key={index}
                                        src={require("../../assets/images/png/theme/login-logo.png")}
                                        alt={`orzax-club-login-logo`}
                                    />
                                ))
                            }
                        </div>
                    ))
                }
            </div>
            <div className={'scroller'}>
                {
                    [...Array(12)].map((_, index) => (
                        <div className={'d-flex justify-content-center align-items-center w-100'}>
                            {
                                [...Array(2)].map((_, index) => (
                                    <img
                                        key={index}
                                        src={require("../../assets/images/png/theme/login-logo.png")}
                                        alt={`orzax-club-login-logo`}
                                    />
                                ))
                            }
                        </div>
                    ))
                }
                {
                    [...Array(12)].map((_, index) => (
                        <div className={'d-flex justify-content-center align-items-center w-100'}>
                            {
                                [...Array(2)].map((_, index) => (
                                    <img
                                        key={index}
                                        src={require("../../assets/images/png/theme/login-logo.png")}
                                        alt={`orzax-club-login-logo`}
                                    />
                                ))
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default LogoScroller;
